import { render, staticRenderFns } from "./configureModel.vue?vue&type=template&id=27e8c09a&scoped=true"
import script from "./configureModel.vue?vue&type=script&lang=js"
export * from "./configureModel.vue?vue&type=script&lang=js"
import style0 from "./configureModel.vue?vue&type=style&index=0&id=27e8c09a&lang=scss&scoped=true"
import style1 from "./configureModel.vue?vue&type=style&index=1&id=27e8c09a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e8c09a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27e8c09a')) {
      api.createRecord('27e8c09a', component.options)
    } else {
      api.reload('27e8c09a', component.options)
    }
    module.hot.accept("./configureModel.vue?vue&type=template&id=27e8c09a&scoped=true", function () {
      api.rerender('27e8c09a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/templateGroupManage/configureModel.vue"
export default component.exports